import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './pages/authentication/service/auth.guard';
import { CheckGuard } from './pages/authentication/service/check.guard';
const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/authentication/login/login.module').then(
        (m) => m.LoginModule
      ),
    canActivate: [CheckGuard],
  },
  {
    path: 'thank-you',
    loadChildren: () =>
      import('./pages/thank-you/thank-you.module').then(
        (m) => m.ThankYouModule
      ),
  },
  {
    path: 'activate/:token',
    loadChildren: () =>
      import('./pages/activate/activate.module').then((m) => m.ActivateModule),
  },
  {
    path: 'activate-confirm/:token',
    loadChildren: () =>
      import('./pages/activate-confirm/activate-confirm.module').then(
        (m) => m.ActivateConfirmModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/authentication/login/login.module').then(
        (m) => m.LoginModule
      ),
    canActivate: [CheckGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import(
        './pages/authentication/forgot-password/forgot-password.module'
      ).then((m) => m.ForgotPasswordModule),
  },
  /* {
     path: 'signup',
     loadChildren: () =>
       import('./pages/authentication/sign-up/sign-up.module').then(
         (m) => m.SignUpModule
       ),
     canActivate: [CheckGuard],
   },*/
  {
    path: 'rem_success/:id',
    loadChildren: () =>
      import('./pages/success-page/success-page.module').then(
        (m) => m.SuccessPageModule
      ),
  },
  /* {
     path: 'prep_success/:id',
     loadChildren: () =>
       import('./pages/prep-success-page/prep-success-page.module').then(
         (m) => m.PrepSuccessPageModule
       ),
   },*/
  {
    path: 'remediation-dashboard',
    loadChildren: () =>
      import('./pages/remediation-dashboard/remediation-dashboard.module').then(
        (m) => m.RemediationDashboardModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: ':id/:token',
    loadChildren: () =>
      import('./pages/authentication/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule
      ),
  },
  /*{
    path: 'license-dashboard',
    loadChildren: () =>
      import('./pages/license-dashboard/license-dashboard.module').then(
        (m) => m.LicenseDashboardModule
      ),
    canActivate: [AuthGuard],
  },*/
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
